/* eslint-disable no-sequences */
/* eslint-disable array-callback-return */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
// import TablePagination from '@material-ui/core/TablePagination';
import TableRow from "@material-ui/core/TableRow";
import "./styles.scss";
import Spinner from "react-spinner-material";

import Eventoervice from "../../services/EventoService";
import AuthContext from "../../auth/index";

import DeleteIcon from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Done from "@material-ui/icons/Done";
import Close from "@material-ui/icons/Close";
import Moment from "moment";

const columns = [
  {
    id: "titulo",
    label: "Título",
    minWidth: 200,
  },
  {
    id: "descricao",
    label: "Descrição",
    minWidth: 100,
  },
  {
    id: "dataInicio",
    label: "Data Início",
    minWidth: 120,
    align: "right",
  },
  {
    id: "dataFim",
    label: "Data Fim",
    minWidth: 120,
    align: "center",
  },
  {
    id: "acoes",
    label: "",
    minWidth: 120,
    align: "right",
  },
];

function createData(titulo, descricao, dataInicio, dataFim, acoes) {
  return { titulo, descricao, dataInicio, dataFim, acoes };
}
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  tableWrapper: {
    overflow: "auto",
  },
  acoes: {
    background: "red",
    fontSize: 80,
  },
});

export default function TableContent(props) {
  const classes = useStyles();
  const page = 0;
  const rowsPerPage = 99;
  const [rows, setRows] = React.useState([]);

  async function removeItem(item, key) {
    let temp = rows;
    temp[key] = await createData(
      item.titulo,
      item.descricao,
      `${Moment(item.dataInicio).format("DD/MM/YYYY")} - ${Moment(
        item.horaInicio
      ).format("HH:MM")}`,
      `${Moment(item.dataFim).format("DD/MM/YYYY")} - ${Moment(
        item.horaFinal
      ).format("HH:MM")}`,
      <div className={"excluindo"}>
        <div>Excluindo</div>
        <Spinner
          size={20}
          spinnerColor={"#0061c6"}
          spinnerWidth={4}
          visible={true}
        />
      </div>
    );

    setRows([...rows, temp]);

    const res = await Eventoervice.deletar(item.id);

    if (res.status === 204) {
      let remove = rows;
      remove[key] = createData(
        item.titulo,
        item.descricao,
        `${Moment(item.dataInicio).format("DD/MM/YYYY")} - ${Moment(
          item.horaInicio
        ).format("HH:MM")}`,
        `${Moment(item.dataFim).format("DD/MM/YYYY")} - ${Moment(
          item.horaFinal
        ).format("HH:MM")}`,
        "Removido"
      );
      setRows([...rows, remove]);
    } else {
      let errorRemove = rows;
      errorRemove[key] = createData(
        item.titulo,
        item.descricao,
        `${Moment(item.dataInicio).format("DD/MM/YYYY")} - ${Moment(
          item.horaInicio
        ).format("HH:MM")}`,
        `${Moment(item.dataFim).format("DD/MM/YYYY")} - ${Moment(
          item.horaFinal
        ).format("HH:MM")}`,
        <div className={"erroRemove"}>
          <div>Erro ao remover item</div>
          {acoes(item, key)}
        </div>
      );
      setRows([...rows, errorRemove]);
    }
  }

  async function aprovarInativar(item, key, status) {
    let temp = rows;
    temp[key] = await createData(
      item.titulo,
      item.descricao,
      `${Moment(item.dataInicio).format("DD/MM/YYYY")} - ${Moment(
        item.horaInicio
      ).format("HH:MM")}`,
      `${Moment(item.dataFim).format("DD/MM/YYYY")} - ${Moment(
        item.horaFinal
      ).format("HH:MM")}`,
      <div className={"excluindo"}>
        <div>Alterando</div>
        <Spinner
          size={20}
          spinnerColor={"#0061c6"}
          spinnerWidth={4}
          visible={true}
        />
      </div>
    );

    setRows([...rows, temp]);

    const payload = item;
    payload.typeStatus = status;

    const res = await Eventoervice.atualizar(payload);
    if (res.status === 201) {
      let remove = rows;
      item.situacao = status;
      remove[key] = createData(
        item.titulo,
        item.descricao,
        `${Moment(item.dataInicio).format("DD/MM/YYYY")} - ${Moment(
          item.horaInicio
        ).format("HH:MM")}`,
        `${Moment(item.dataFim).format("DD/MM/YYYY")} - ${Moment(
          item.horaFinal
        ).format("HH:MM")}`,
        acoes(item, key)
      );
      setRows([...rows, remove]);
    } else {
      let errorRemove = rows;
      errorRemove[key] = createData(
        item.titulo,
        item.descricao,
        `${Moment(item.dataInicio).format("DD/MM/YYYY")} - ${Moment(
          item.horaInicio
        ).format("HH:MM")}`,
        `${Moment(item.dataFim).format("DD/MM/YYYY")} - ${Moment(
          item.horaFinal
        ).format("HH:MM")}`,
        <div className={"erroRemove"}>
          <div>Erro ao alterar o item</div>
          {acoes(item, key)}
        </div>
      );
      setRows([...rows, errorRemove]);
    }
  }

  function changeItem(item, key) {
    props.editItem(item, key);
  }

  function acoes(item, key) {
    const validaAprovar = item.situacao === "APROVADO" ? false : true;

    // if (item.situacao === 'CONCLUIDA') {
    //   return (
    //     <div>Enviado</div>
    //   )
    // }
    return (
      <AuthContext.Consumer>
        {({ hasRole }) => (
          <div className={"btnAcoes"}>
            {hasRole("NA_PALMA_ADMIN") &&
              item.typeStatus === "CRIADO" && (
                <div
                  onClick={() => {
                    validaAprovar && aprovarInativar(item, key, "APROVADO");
                  }}
                >
                  <Done className={"acoes send"} />
                  <span>Aprovar</span>
                </div>
              )}
            {hasRole("NA_PALMA_ADMIN") &&
              item.typeStatus === "APROVADO" && (
                <div
                  onClick={() => {
                    validaAprovar && aprovarInativar(item, key, "CRIADO");
                  }}
                >
                  <Close className={"acoes"} color="error" />
                  <span>Inativar</span>
                </div>
              )}
            <div onClick={() => changeItem(item, key)}>
              <Edit className={"acoes"} color="primary" />
              <span>Editar</span>
            </div>
            <div
              onClick={() => {
                removeItem(item, key);
              }}
              className={"acoes"}
            >
              <DeleteIcon color="error" />
              <span>Deletar</span>
            </div>
          </div>
        )}
      </AuthContext.Consumer>
    );
  }

  if (!rows.length) {
    let incrementTable = [];
    props.content.map(
      (item, key) => (
        (incrementTable = createData(
          item.titulo,
          item.descricao,
          `${Moment(item.dataInicio).format("DD/MM/YYYY")} - ${Moment(
            item.horaInicio
          ).format("HH:MM")}`,
          `${Moment(item.dataFim).format("DD/MM/YYYY")} - ${Moment(
            item.horaFinal
          ).format("HH:MM")}`,
          acoes(item, key)
        )),
        rows.push(incrementTable)
      )
    );
  }

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, key) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={key}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === "number"
                          ? column.format(value)
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            {!rows.length && (
              <TableRow>
                <TableCell>Nenhum push cadastrado!</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      {/* <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                    'aria-label': 'previous page',
                }}
                nextIconButtonProps={{
                    'aria-label': 'next page',
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            /> */}
    </Paper>
  );
}
